export const isNativeApp = typeof window.ReactNativeWebView !== "undefined";
